import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AlertGeral, requisitarAPI } from "../../components/AlertGeral";
import Listagem from "../../components/ListagemTag";
import { colunasListaTagsConsultorio } from "../../components/ListagemTag/colunas";
import MainMenu from "../../components/MainMenu";
import Spinner from "../../components/Spiner";
import "../../Global/styleGeral.css";
import api from "../../services/api";
import { Creators as ListaTagsAction } from "../../Store/Controls/listaTags";

import { faPlus, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ListaTags = ({ history, match }) => {
  const [retorno, setRetorno] = useState({}); // resposta do servidor
  const [loading, setLoading] = useState(true); // carregando

  const listasEsperas = useSelector((state) => state.listaTags);
  const dispatch = useDispatch();
  const tipo = match.params.tipo;
  const url_edit = `listaTags/editar/${tipo}`; // url para editar

  async function getDados() {
    let ret = await requisitarAPI(
      () => api.get(`listaTags/${tipo}`),
      "Falha ao obter dados do servidor"
    );
    setRetorno(ret.response.data);

    if (!ret.erro) {
      dispatch(ListaTagsAction.addTags(ret.response.data));
    }

    setLoading(false);
  }

  useEffect(() => {
    getDados();
  }, []);

  return (
    <>
      <MainMenu navigation={history} />

      <div className="titulo-pagina">
        Lista de Tags
        <Button
          variant="principal"
          onClick={() => {
            history.push(`/listaTags/cadastro/${tipo}`);
          }}
          alt="Adicione uma nova tag"
          title="Adicione uma nova tag"
        >
          <FontAwesomeIcon className="icone" icon={faPlus} /> Nova tag
        </Button>
        <a
          href="/ajuda"
          alt="Clique para acessar página de ajuda"
          style={{ float: "right" }}
          title="Clique para acessar página de ajuda"
        >
          <FontAwesomeIcon className="icone" icon={faQuestionCircle} />
        </a>
        <AlertGeral retorno={retorno} />
        <Spinner loading={loading} />
      </div>

      <div className="container-principal">
        <Row>
          <Listagem
            dados={listasEsperas}
            cols={colunasListaTagsConsultorio}
            url_edit={url_edit}
            tipo_delete="listaTags"
            history={history}
          />
        </Row>
      </div>
    </>
  );
};

export default ListaTags;
